export class I18n {
    public language = 'ru';
}
